module.exports = __webpack_public_path__ + "static/together_bg5-93d7e67d8c7d105547319cdc41baa2fc.png";